import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Cookies from "js-cookie"; // Import js-cookie
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MDTypography from "components/MDTypography";
import { Typography, Box } from "@mui/material";
import MDBox from "components/MDBox";
import Breadcrumbs from "examples/Breadcrumbs";
import { getBackgroundColor } from "components/StyledComponents/styledComponents";
import BusinessIcon from "@mui/icons-material/Business";

import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

function DashboardNavbar({ absolute, light, isMini }) {
  const [controller, dispatch] = useMaterialUIController();
  const route = useLocation().pathname.split("/").slice(1);
  const bColor = getBackgroundColor(controller);
  const navigate = useNavigate();
  const { user } = controller;

  return (
    <AppBar
      position="relative"
      color="inherit"
      sx={{
        backgroundColor: "white",
        top: 10,
        zIndex: 1100,
        height: "40px",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          px: 3,
        }}
      >
        <MDBox
          sx={{
            position: "absolute",
            top: 6,
            left: 16,
          }}
        >
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox>

        <Card
          sx={{
            borderRadius: "8px",
            boxShadow: "none",
            display: { xs: "none", sm: "flex" }, // Hide on xs, show from sm+
            alignItems: "center",
            justifyContent: "center",
            position: "absolute", // Position inside AppBar
            top: "7px", // Moves it down by 10px
          }}
        >
          <MDTypography
            fontWeight="bold"
            textTransform="capitalize"
            variant="h6"
            color={"dark"}
            noWrap
          >
            {route.length > 0 ? route[route.length - 1].replace("-", " ") : "Dashboard"}
          </MDTypography>
        </Card>

        {/* {!isMini && (
          <MDBox
            sx={{
              position: "absolute",
              right: 16,
              top: 6,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <BusinessIcon sx={{ fontSize: "18px", color: "primary.main" }} />
            <Typography
              sx={{
                fontSize: { xs: "12px", md: "15px" },
                backgroundColor: "#E59400",
                color: "white",
                px: 2,
                py: 0.5,
                borderRadius: "12px",
                boxShadow: 1,
                fontWeight: "bold",
                color: "#ffffff",
              }}
              variant="subtitle2"
            >
              <span style={{ color: "black" }}> DSA: </span>
              {user?.dsaName || "Unknown"}
            </Typography>
          </MDBox>
        )} */}
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
